var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 19,
    width: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39 2.541h4.499M2.89 4.791h13.497m-1.5 0-.526 7.887c-.079 1.184-.118 1.775-.374 2.224a2.25 2.25 0 0 1-.973.91c-.465.226-1.058.226-2.244.226H8.507c-1.186 0-1.779 0-2.243-.225a2.25 2.25 0 0 1-.974-.911c-.256-.449-.295-1.04-.374-2.224L4.39 4.79",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.687
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e7cca9f389a9b14606ce2d7174e2fc43.svg";
export { ForwardRef as ReactComponent };